import { render, staticRenderFns } from "./BankAndBankBranchSuggest.vue?vue&type=template&id=99d16f80"
import script from "./BankAndBankBranchSuggest.vue?vue&type=script&lang=js"
export * from "./BankAndBankBranchSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports